export enum PeriodType {
  Forthcoming = 'forthcoming',
  Ongoing = 'ongoing',
  Past = 'past',
}
